export default "__VITE_ASSET__d2d008cc__"